import { TipoBecaReq } from './tipoBecaReq';
import { TipoBecaReqCentro } from './tipoBecaReqCentro';
import { TipoBecaReqSeccion } from './tipoBecaReqSeccion';

export class TipoBecaReqEspecificaciones{

    TipoBecaRequisito: TipoBecaReq;
    BecaRequisitoSecciones : TipoBecaReqSeccion[];
    BecaRequisitoCentros: TipoBecaReqCentro[];
}